import React, {
  useCallback,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import FirebaseContext from '../../../../../context/FirebaseContext';
import useToast from '../../../../hooks/useToast';
import ConfirmDialog from '../../../ConfirmDialog';
import { cancelCalDotComMeeting } from '../../utils';

import texts from './texts.json';

const CalDotComMeetingCancelModal = ({
  leadId,
  onClose,
  setLoading,
}) => {
  const { showToast } = useToast();
  const { firebase: { remote } } = useContext(FirebaseContext);

  const onCancelMeeting = useCallback(async () => {
    setLoading(true);
    const { success, error } = await cancelCalDotComMeeting(remote, leadId);
    if (success) {
      showToast(texts.cancellationSuccess);
      onClose();
    } else {
      showToast(format(texts.cancellationError, { error }), { error: true });
    }
    setLoading(false);
  }, [
    showToast,
    leadId,
    setLoading,
    onClose,
    remote,
  ]);

  return (
    <ConfirmDialog
      isOpen
      onConfirm={onCancelMeeting}
      onCancel={onClose}
      dialogTexts={{
        title: texts.title,
        content: texts.content,
        confirm: texts.saveButton,
        cancel: texts.close,
      }}
    />
  );
};

CalDotComMeetingCancelModal.propTypes = {
  leadId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default CalDotComMeetingCancelModal;
